// extracted by mini-css-extract-plugin
var _1 = "TaskStatusToggle-moduleTaskStatusToggle__Vt1Y5";
var _2 = "TaskStatusToggle-moduleloadingIcon__huYyn";
var _3 = "TaskStatusToggle-moduleloadingOverlay__TWuN2";
var _4 = "TaskStatusToggle-moduleno__aB3xS";
export { _1 as "TaskStatusToggle", _2 as "loadingIcon", _3 as "loadingOverlay", _4 as "no" }
